import React, { useEffect, useState } from 'react'
import { suggestionListService } from '../../_services'
import { useTranslation } from "react-i18next";
import { GoogleMap, LoadScript, Marker, MarkerClusterer, InfoWindow, HeatmapLayer, LatLng } from '@react-google-maps/api';
import moment from 'moment'
import { history } from '../../_helpers';
import { useParams } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap'

function SuggestionListMap() {

	const {uuid} = useParams()
	const [suggestions, setSuggestions] = React.useState([])
	const [map, setMap] = React.useState(null)
	const [selectedSuggestion, setSelectedSuggestion] = React.useState(null)
	const [showModal, setShowModal] = React.useState(false)
	const {t} = useTranslation('common');

    const containerStyle = {
		width: '100%',
		height: '85vh'
    };

    const onLoad = React.useCallback(function callback(map) {
        console.log('onLoad')
	    //const bounds = new window.google.maps.LatLngBounds();
	    //map.fitBounds(bounds);

	    setMap(map)

	    map.setZoom(10)
	    map.setCenter({ lat: 0, lng: 0 })

	    suggestionListService.get(uuid).then(suggestionList => {
	        var existingLatLngs = []
	        suggestionList.suggestions.forEach(suggestion => {
	            var key = suggestion.lat + '-' + suggestion.lng
	            while (existingLatLngs.indexOf(key) >= 0) {
	                suggestion.lng += 0.00001
	                key = suggestion.lat + '-' + suggestion.lng
	            }
	            existingLatLngs.push(key)
	        })

	        setSuggestions(suggestionList.suggestions)

	        const bounds = new window.google.maps.LatLngBounds();
	        suggestionList.suggestions.map(suggestion => {
	            if (suggestion.lat != 1000 && suggestion.lng != 1000) {
	                bounds.extend(suggestion)
	            }
	        })
	        map.fitBounds(bounds);
	    })
	}, [])

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null)
	}, [])

	const handleCenter = () => {
	    if (map === null)
	        return
    }

    const options = {
		imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
		maxZoom: 21
    }

    const onMarkerClick = suggestion => {
		console.log(suggestion)
		setSelectedSuggestion(suggestion.text)
		setShowModal(true)
    }

	return (
		<div>
			<h2>
                {t('map.label')}
            </h2>
            <GoogleMap
		        mapContainerStyle={containerStyle}
		        onLoad={onLoad}
		        onUnmount={onUnmount}
		        onDragEnd={handleCenter}
		        //onZoomChanged={() => console.log(map.getZoom())}
		        options={{ minZoom: 3, zoomControl: true }}>
	            <MarkerClusterer options={options}>
		            {(clusterer) =>
		                suggestions.filter(suggestion => suggestion.lat != 1000 && suggestion.lng != 1000).map(suggestion => (
		                    <Marker
			                    key={suggestion.id}
			                    position={suggestion}
			                    clusterer={clusterer}
			                    title={suggestion.name}
			                    onClick={() => onMarkerClick(suggestion)}
			                    marker={suggestion}
			                />
		                ))
		            }
                </MarkerClusterer>
			</GoogleMap>
			<Modal
				style={{overflow: 'scroll'}}
				size="sm"
				show={showModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={() => setShowModal(false)}
				animation={false}
				centered>
				<Modal.Body>
					{selectedSuggestion}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={() => setShowModal(false)}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
        </div>
	)
}

export default SuggestionListMap;